import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <h1 className="moving-text">Reserva tu clase gratuita ahora</h1>
    </header>
  );
};

export default Header;
